import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kgrill183.com';

const schemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '케이그릴183',
    alternateName: 'K-Grill183',
    description:
      '케이그릴183은 세로 숯불구이 기술로 전통 숯불구이를 대량생산 가능한 식품 인프라로 바꾸는 혁신 기업입니다. 일일 1만팩 생산, 냉장 5.5개월 유통을 실현합니다.',
    url: siteUrl,
    email: 'info@kgrill183.com',
    foundingDate: '2024',
    industry: 'Food Technology',
    logo: 'https://static.readdy.ai/image/17b7b4fe0c11dd66d6ca2f4f9437a472/96788b68209b0eb4015e90aa725a9998.png',
    sameAs: [],
    knowsAbout: ['숯불구이 산업화', '세로 숯불구이', '케이그릴183', 'HMR 식품', 'K-푸드 수출'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '케이그릴183 K-Grill183',
    alternateName: ['케이그릴183', 'K-Grill183', '케이그릴 183'],
    url: siteUrl,
    description: '케이그릴183 공식 웹사이트 — 숯불구이 산업화 혁신 기술',
    inLanguage: 'ko-KR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: '케이그릴183 세로 숯불구이 시스템',
    alternateName: 'K-Grill183',
    description:
      '케이그릴183의 세로 숯불구이 구조로 일일 1만팩 대량생산, 냉장 5.5개월 유통이 가능한 혁신적인 식품 산업화 시스템',
    brand: {
      '@type': 'Brand',
      name: '케이그릴183',
    },
    manufacturer: {
      '@type': 'Organization',
      name: '케이그릴183',
      alternateName: 'K-Grill183',
    },
    category: '식품 산업화 시스템',
    url: siteUrl,
    image:
      'https://static.readdy.ai/image/17b7b4fe0c11dd66d6ca2f4f9437a472/17f0181c5c666dd6f25cb0f987bfd62c.png',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '케이그릴183 K-Grill183 | 숯불구이 산업화 혁신 기술 | 세로 숯불구이 시스템',
    url: siteUrl,
    description:
      '케이그릴183(K-Grill183)은 세로 숯불구이 기술로 전통 숯불구이를 대량생산 가능한 식품 인프라로 바꿉니다.',
    inLanguage: 'ko-KR',
    isPartOf: {
      '@type': 'WebSite',
      url: siteUrl,
      name: '케이그릴183 K-Grill183',
    },
    about: {
      '@type': 'Organization',
      name: '케이그릴183',
      url: siteUrl,
    },
    dateModified: '2026-03-30',
  },
];

export default function SEOJsonLD() {
  useEffect(() => {
    const injected: HTMLScriptElement[] = [];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.setAttribute('data-seo-jsonld', 'true');
      document.head.appendChild(script);
      injected.push(script);
    });

    return () => {
      injected.forEach((s) => {
        if (document.head.contains(s)) {
          document.head.removeChild(s);
        }
      });
    };
  }, []);

  return null;
}
